import filterOperations from '../../filters/operations';
import actions from './actions';
import * as selectors from './selectors';
import { createCoverageOperations } from '../../../common/coverage/operations';

const operations = {};
export default Object.assign(
  operations,
  createCoverageOperations({
    actions,
    selectors,
    operations,
    filterOperations,
    type: 'vdc',
  }),
);
